import { Component } from '@angular/core';

@Component({
  selector: 'app-arguments',
  templateUrl: './arguments.component.html',
  styleUrls: ['./arguments.component.scss']
})
export class ArgumentsComponent {

}
